// CAMSRBT-15205 tier badge: a small tier icon (Bronze/Silver/Gold/Diamond)
// shown right of a member's handle in the broadcaster chat and viewers list.
// Renders ONLY for members with a TIERED fanclub membership (fanTier 1-4 from
// nodechat user info; legacy tier-0 members and non-members get no badge) -
// tier memberships only exist once the tiered-fanclub launch flags are on, so
// this is dormant until then.

export const TIER_BADGE_LETTERS: Record<number, string> = {
  1: "B",
  2: "S",
  3: "G",
  4: "D",
};

export const TIER_BADGE_COLORS: Record<number, string> = {
  1: "#cd7f32", // bronze
  2: "#8e9aa6", // silver
  3: "#d4af37", // gold
  4: "#35a7e0", // diamond
};

export const TIER_BADGE_BASE_STYLE = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 14,
  height: 14,
  borderRadius: "50%",
  fontSize: 9,
  fontWeight: 700,
  lineHeight: 1,
  color: "#fff",
  marginLeft: 4,
  marginRight: 2,
  verticalAlign: "middle",
} as const;

export const getTierBadgeTier = (
  fanTier: number | undefined | null
): number | null => {
  const tier = Number(fanTier);
  return tier >= 1 && tier <= 4 ? tier : null;
};

export const TIER_BADGE_NAMES: Record<number, string> = {
  1: "Bronze",
  2: "Silver",
  3: "Gold",
  4: "Diamond",
};

// CAMSRBT-15205: tier badge as an image icon (same artwork as the member-site
// chat), replacing the colored circle + letter. Sized to match the old circle
// (14px). All tiers use the PNG artwork — the -chat.svg variants embed a base64
// image with a malformed `data:img/png` MIME type that browsers can't decode, so
// silver/gold/bronze rendered blank (only the direct-PNG Diamond showed).
export const TIER_BADGE_ICONS: Record<number, string> = {
  1: "/images/fanclub/tier-bronze-chat.png",
  2: "/images/fanclub/tier-silver-chat.png",
  3: "/images/fanclub/tier-gold-chat.png",
  4: "/images/fanclub/tier-diamond-chat.png",
};

export const TIER_BADGE_IMG_STYLE = {
  // display inline-block so the badge stays on the same line as the handle/text
  // (a global reset sets img -> display:block, which otherwise breaks the chat
  // line between username, icon, and message).
  display: "inline-block",
  width: 14,
  height: 14,
  objectFit: "contain",
  marginLeft: 4,
  marginRight: 2,
  verticalAlign: "middle",
} as const;
